export default function isAvailabilityEqual (search, otherSearch) {
    return (
        search.parkingId === otherSearch.parkingId &&
        search.startDate === otherSearch.startDate &&
        search.endDate === otherSearch.endDate
    )
}
